import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import Areas from './Areas.vue';

const AreasRoutes = {
  path: 'areas',
  component: EmptyRouterView,
  children: [
    {
      path: '',
      name: 'common_words.area2',
      component: Areas,
      meta: {
        prefix_permission: 'areas',
      },
    },
  ],
};

export default AreasRoutes;
